var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo",attrs:{"dir":"rtl"}},[_c('h1',{staticStyle:{"text-align":"center"}},[_vm._v("ویرایشگر")]),_c('editor',{ref:"editor",attrs:{"config":_vm.config,"initialized":_vm.onInitialized}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }